import type { ReactNode } from 'react';

/**
 * A record's form, read before it is edited (owner, 2026-09-27: "on click on datagrid ... shall
 * show detailed view. with an option to edit"). Viewing, every control is disabled and styled as
 * plain text - no borders, no arrows, no upload boxes, no hints - so the drawer reads as the
 * record's details; Edit takes the lock off. `display: contents` keeps the drawer's own layout.
 */
export function ViewModeFieldset({ viewing, children }: { viewing: boolean; children: ReactNode }) {
  return <fieldset className={viewing ? 'form-view' : 'form-edit'} disabled={viewing}>{children}</fieldset>;
}
